import React, { lazy, Suspense } from "react";

const ReactJson = lazy(() => import("react-json-view"));

// react-json-view renders Date values via its own formatter, which drops the timezone.
// Pre-stringify Dates as ISO 8601 (UTC, trailing Z) so the dump is unambiguous.
const isoifyDates = (input: any): any => {
    if (input instanceof Date) return input.toISOString();
    if (Array.isArray(input)) return input.map(isoifyDates);
    if (input && typeof input === "object") {
        const out: Record<string, any> = {};
        for (const k of Object.keys(input)) out[k] = isoifyDates(input[k]);
        return out;
    }
    return input;
};

const JsonViewer: React.FC<{ data: any }> = ({ data }) => {
    const safeData = data ? isoifyDates(data) : data;
    return (
        <Suspense fallback={<div>Loading JSON viewer...</div>}>
            {safeData && <ReactJson  src={safeData} theme="rjv-default" />}
        </Suspense>
    );
};

export default JsonViewer;